/* Ordinia v11: detalles de compra y portada.
   1. Las cifras de los destacados cuentan hacia arriba al entrar en pantalla (una vez).
   2. El botón de añadir al carrito de la ficha da un destello al aparecer (una vez). La fila de confianza ya la pone el bloque «Ordinia: confianza».
   Sin dependencias. IntersectionObserver, nunca listeners de scroll. */
(function () {
  'use strict';

  var ease = function (t) { return 1 - Math.pow(1 - t, 4); };

  /* ---------- 1. Cifras que cuentan ---------- */
  // Solo números sencillos ("450 r/min", "1,3 L", "0,55 €", "5"). Los rangos ("50–90 min", "5 a 40") se dejan tal cual.
  var NUM = /^(\d+(?:[.,]\d+)?)(\s*\D.*)?$/;

  function prepCount(dt) {
    if (dt.dataset.ord11Count) return null;
    var raw = (dt.textContent || '').trim();
    var m = raw.match(NUM);
    if (!m || /\d/.test(m[2] || '') || /\s(a|y)\s/.test(raw)) return null;
    var str = m[1];
    var sep = str.indexOf(',') > -1 ? ',' : '.';
    var decimals = (str.split(/[.,]/)[1] || '').length;
    var target = parseFloat(str.replace(',', '.'));
    if (!isFinite(target) || target === 0) return null;
    dt.dataset.ord11Count = '1';
    dt.setAttribute('aria-label', raw);
    return { el: dt, target: target, decimals: decimals, sep: sep, rest: m[2] || '', raw: raw };
  }

  function runCount(c) {
    var start = null, dur = 1100;
    function fmt(v) {
      var s = v.toFixed(c.decimals);
      return (c.sep === ',' ? s.replace('.', ',') : s) + c.rest;
    }
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      c.el.textContent = fmt(c.target * ease(t));
      if (t < 1) requestAnimationFrame(frame); else c.el.textContent = c.raw;
    }
    c.el.textContent = fmt(0);
    requestAnimationFrame(frame);
  }

  function initCounts(root) {
    var items = [];
    (root || document).querySelectorAll('.ord-dst__fact dt').forEach(function (dt) {
      var c = prepCount(dt);
      if (c) items.push(c);
    });
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var c = items.find(function (x) { return x.el === e.target; });
        if (c) runCount(c);
      });
    }, { threshold: 0.6 });
    items.forEach(function (c) { io.observe(c.el); });
  }

  /* ---------- 2. Botón de compra de la ficha ---------- */
  function initBuy(root) {
    var scope = (root || document);
    var btns = scope.querySelectorAll('.product-information add-to-cart-component .add-to-cart-button, .product-details add-to-cart-component .add-to-cart-button');
    btns.forEach(function (btn) {
      if (btn.dataset.ord11) return;
      // Fuera de diálogos (compra rápida) y de la barra fija
      if (btn.closest('dialog, .sticky-add-to-cart, .ord-sticky, quick-add-modal')) return;
      btn.dataset.ord11 = '1';

      // Destello una vez al aparecer
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          io.disconnect();
          btn.classList.add('ord11-glint');
          setTimeout(function () { btn.classList.remove('ord11-glint'); }, 1600);
        }, { threshold: 0.9 });
        io.observe(btn);
      }
    });
  }

  function init(root) { initCounts(root); initBuy(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
